// Bezorgbericht bepalen op basis van de huidige dag en tijd
// - Maandag t/m vrijdag: tot 23:30 "Voor 23:30 besteld, [morgen] in huis", daarna schuift de dag een dag door
// - Zaterdag: altijd "Voor 23:59 besteld, maandag in huis"
// - Zondag: tot 21:00 "Voor 21:00 besteld, maandag in huis", daarna schuift de dag een dag door
var deliveryDayNames = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

// Er wordt niet op zondag bezorgd. Zonder deze correctie belandt een bestelling op
// vrijdag na 23:30 (+2 dagen) op zondag.
function nooitZondag(date) {
  if (date.getDay() === 0) date.setDate(date.getDate() + 1);
  return date;
}

// Cut-off en verwachte bezorgdatum in één keer bepalen, zodat het getoonde bericht en de datum
// die we in de bestelling opslaan altijd op dezelfde berekening zijn gebaseerd.
function getDeliveryInfo() {
  var now = new Date();
  var day = now.getDay(); // 0 = zondag, 1 = maandag, ..., 6 = zaterdag
  var totalMinutes = now.getHours() * 60 + now.getMinutes();
  var cutoffReached;
  var cutoffLabel;

  if (day === 6) { // Zaterdag
    cutoffReached = true;
    cutoffLabel = '23:59';
  } else if (day === 0) { // Zondag, cutoff 21:00
    cutoffReached = totalMinutes >= (21 * 60);
    cutoffLabel = '21:00';
  } else { // Maandag t/m vrijdag, cutoff 23:30
    cutoffReached = totalMinutes >= (23 * 60 + 30);
    cutoffLabel = '23:30';
  }

  var daysToAdd = cutoffReached ? 2 : 1;
  var deliveryDate = new Date(now);
  deliveryDate.setDate(now.getDate() + daysToAdd);

  return { date: nooitZondag(deliveryDate), cutoffLabel: cutoffLabel };
}

function calculateDeliveryMessage() {
  var info = getDeliveryInfo();
  return 'Voor ' + info.cutoffLabel + ' besteld, ' + deliveryDayNames[info.date.getDay()] + ' in huis';
}

// Volledige datum voor in de bestelling/bevestigingsmail, bijv. "woensdag 23 september 2026".
// In de drawer blijft de korte tekst staan; dit is alleen wat we opslaan.
function formatExpectedDeliveryDate(date) {
  return date.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

// Bezorgbericht bijwerken
function updateDeliveryMessage() {
  var messageElements = document.querySelectorAll('#delivery-message');
  var newMessage = calculateDeliveryMessage();

  messageElements.forEach(function(messageElement) {
    // Alleen schrijven als de tekst echt wijzigt: voorkomt een oneindige lus met de MutationObserver
    // hieronder, die ook naar wijzigingen binnen dit element luistert.
    if (messageElement.innerHTML !== newMessage) {
      messageElement.innerHTML = newMessage;
    }
  });

  saveExpectedDelivery();
}

// ---------- Verwachte bezorgdatum opslaan als cart attribute ----------
// Het hidden input in cart-drawer.liquid dekt alleen de checkout-knop in die ene form. Daarom
// schrijven we de waarde daarnaast naar /cart/update.js: dan hangt de datum aan de cart zelf en
// komt hij mee ongeacht via welke route er wordt afgerekend (cart-pagina, dynamic checkout, enz.).
var LAST_SAVED_EXPECTED_DELIVERY = null;
var SAVE_EXPECTED_DELIVERY_TIMER = null;

function saveExpectedDelivery() {
  // Het hidden input bestaat alleen als de cart gevuld is; bij een lege cart slaan we niets op
  // (voorkomt dat er een cart wordt aangemaakt voor bezoekers die nog niets hebben toegevoegd).
  var input = document.getElementById('attr-expected-delivery');
  if (!input) return;

  var value = formatExpectedDeliveryDate(getDeliveryInfo().date);
  input.value = value;

  // Alleen versturen als de datum echt wijzigt. De cart-drawer rendert zichzelf opnieuw na een
  // cart-update, wat de MutationObserver triggert; zonder deze check zou dat blijven rondlopen.
  if (value === LAST_SAVED_EXPECTED_DELIVERY) return;
  LAST_SAVED_EXPECTED_DELIVERY = value;

  if (SAVE_EXPECTED_DELIVERY_TIMER) clearTimeout(SAVE_EXPECTED_DELIVERY_TIMER);
  SAVE_EXPECTED_DELIVERY_TIMER = setTimeout(function() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { expected_delivery: value } })
    }).catch(function() {
      // Stil falen: de bezorgdatum is aanvullende info, een mislukte call mag de cart niet blokkeren.
      // Bij een volgende wijziging wordt het opnieuw geprobeerd.
      LAST_SAVED_EXPECTED_DELIVERY = null;
    });
  }, 250);
}

document.addEventListener('DOMContentLoaded', function() {
  updateDeliveryMessage();
  setInterval(updateDeliveryMessage, 60000);

  // De cart-drawer vervangt zijn inhoud via innerHTML na cart-wijzigingen (toevoegen/verwijderen/aantal
  // aanpassen), zonder DOMContentLoaded of dit script opnieuw te laten draaien. Een MutationObserver vangt
  // dat betrouwbaar op, ongeacht de (soms vertraagde/asynchrone) manier waarop de cart-drawer ververst.
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer && window.MutationObserver) {
    new MutationObserver(updateDeliveryMessage).observe(cartDrawer, { childList: true, subtree: true });
  }
});

document.addEventListener('shopify:section:load', updateDeliveryMessage);

// Bij een variantwissel vervangt het thema het inventory-blok door verse server-HTML
// (zie onRerender_fn in theme.js: 'inventory' staat in de lijst met vervangen blokken).
// Het nieuwe <span id="delivery-message"> is leeg, dus we vullen het direct opnieuw.
// Zonder dit blijft de bezorgdatum weg tot de eerstvolgende interval-tick, tot een minuut later.
//
// 'variant:change' wordt door het thema pas ná het vervangen verstuurd, dus op dat moment
// staat de nieuwe HTML er al. De setTimeout is een vangnet voor het geval een andere
// component de volgorde omdraait; een dubbele aanroep is onschadelijk omdat
// updateDeliveryMessage alleen schrijft als de tekst echt wijzigt.
document.addEventListener('variant:change', function () {
  updateDeliveryMessage();
  setTimeout(updateDeliveryMessage, 0);
}, true);
